import { useState } from 'react';
import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Img } from '../Img/Img.es.js';
import { SkeletonBlock } from '../SkeletonLoader/SkeletonBlock/SkeletonBlock.es.js';

const Styles = labelStyles("LoadableImg", {
  placeholder: css`
    position: absolute;
    left: -9999;
  `
});
const ImgSkeletonLoader = (props) => {
  const [ratioWidth, ratioHeight] = (props.aspectRatio || "").split(":").map((part) => {
    return part && parseFloat(part);
  });
  const aspectRatio = ratioWidth && ratioHeight ? ratioWidth / ratioHeight : void 0;
  return jsx(SkeletonBlock, { aspectRatio, height: props.height, width: props.width === null ? void 0 : props.width });
};
const LoadableImg = (props) => {
  const [loaded, setLoaded] = useState(false);
  const onLoad = (event) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(event);
    }
    setLoaded(true);
  };
  return jsx(
    "div",
    { "data-zds": true },
    jsx(
      "div",
      { css: loaded ? void 0 : Styles.placeholder, "data-zds": true },
      jsx(Img, Object.assign({}, props, { onLoad }))
    ),
    !loaded && jsx(ImgSkeletonLoader, Object.assign({}, props))
  );
};

export { LoadableImg };
//# sourceMappingURL=LoadableImg.es.js.map
